import $ from "jquery";

class SectionBlockListNews {
    constructor() {

        let dropdown = $(".select-cat-mobile");

        $(dropdown).on('click', function (event) {
            event.preventDefault();
            $('.filter-categs-blog').toggleClass('active');
        })
    }
}

export default SectionBlockListNews;